/*global require */

import BasePublicCompanyView from "./base_public_company_view";

export default function getView() {
  return BasePublicCompanyView;
}
